import { Controller } from 'stimulus'

/**
 * @class VideoPosterController
 * @memberof Controllers
 */
export default class extends Controller {
  /**
   * @function Controllers.VideoPosterController.play
   * @memberof Controllers
   * @description Replaces the poster image with an autoplaying YouTube iframe
   */
  play() {
    const iframe = document.createElement('iframe')
    iframe.src = `https://www.youtube.com/embed/${this.data.get('id')}?autoplay=1&modestbranding=1&showinfo=0&rel=0`
    iframe.setAttribute('allow', 'autoplay; encrypted-media')
    iframe.setAttribute('allowfullscreen', true)
    iframe.className = 'evergreen-videos__video-iframe'
    this.element.innerHTML = ''
    this.element.appendChild(iframe)
  }
}
